import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleInfo = (props) => {
    if (process.env.NODE_ENV !== "production") {
        if (props["aria-hidden"] !== "true" &&
            props["aria-label"] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256s114.6 256 256 256zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" }) }));
};
export default SvgCircleInfo;
